/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "assets/theme/base/colors";
import {createDateStrForV7HiddenInputFromSections} from "@mui/x-date-pickers/internals";

const { info, dark,background ,secondary} = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  '&::-webkit-scrollbar':{
    width: '12px !important',
    height: '12px',
    backgroundColor: 'transparent',
  },
  '*::-webkit-scrollbar':{
    width: '12px !important',
    height: '12px',
    backgroundColor: 'transparent',
  },
  '&:hover::-webkit-scrollbar':{
    width: '12px !important',
    height: '12px',
  },
  '*:hover::-webkit-scrollbar':{
    width: '12px !important',
    height: '12px',
  },
  '&::-webkit-scrollbar-track':{
    backgroundColor: 'transparent',
  },
  '*::-webkit-scrollbar-track':{
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-corner':{
    backgroundColor: 'transparent',
  },
  '*::-webkit-scrollbar-corner':{
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'transparent',
    borderRadius: '6px',
    border: '3px solid transparent',
    backgroundClip: 'content-box',
  },
  '*::-webkit-scrollbar-thumb': {
    background: 'transparent',
    borderRadius: '6px',
    border: '3px solid transparent',
    backgroundClip: 'content-box',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: secondary.main,
  },
  '*:hover::-webkit-scrollbar-thumb': {
    backgroundColor: secondary.main,
  },
  '&::-webkit-scrollbar-thumb:hover ':{
    backgroundColor: secondary.focus,
    border: '0',
  },
  '*::-webkit-scrollbar-thumb:hover':{
    backgroundColor: secondary.focus,
    border: '0',
  },

  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 50ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },

};

export default globals;
